import Splide from '@splidejs/splide';
import { getSetItems } from './set_naehwerte';
function initSplideSlider() {
  if (document.querySelectorAll('.splide-slider-cats').length > 0) {
    new Splide('.splide-slider-cats', {
      fixedWidth: '200px',
      drag: 'free',
      gap: '30px',
      mediaQuery: 'min',
      pagination: false,
      arrows: false,
      breakpoints: {
        768: {
          perPage: 3,
          fixedWidth: false,
          arrows: true,
        },
        992: {
          perPage: 4,
          fixedWidth: false,
          arrows: true,
        },
      },
    }).mount();
  }

  if (document.querySelectorAll('.list-item-slide').length > 0) {
    document.querySelectorAll('.list-item-slide').forEach((slide) => {
      new Splide(slide, {
        fixedWidth: '180px',
        drag: 'free',
        gap: '30px',
        mediaQuery: 'min',
        arrows: false,
        pagination: false,
        breakpoints: {
          768: {
            perPage: 3,
            fixedWidth: false,
            arrows: true,
          },
          992: {
            perPage: 4,
            fixedWidth: false,
          },
        },
      }).mount();
    });
  }
  if (document.querySelectorAll('.splide-slider-stepbystep').length > 0) {
    new Splide('.splide-slider-stepbystep', {
      fixedWidth: '180px',
      drag: 'free',
      gap: '15px',
      mediaQuery: 'min',
      pagination: false,
      arrows: false,
      breakpoints: {
        768: {
          fixedWidth: '252px',
        },
        992: {
          destroy: true,
          gap: '30px',
        },
      },
    }).mount();
  }
}
initSplideSlider();
window.initSplideSlider = initSplideSlider;
if (window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initSplideSlider();
  });
}
window.addEventListener('load', (event) => {
  initSplideSlider();
});
document.addEventListener('DOMContentLoaded', function () {
  let timeoutHandle;

  document.querySelectorAll('.mega-menu').forEach((menu) => {
    menu.addEventListener('mouseenter', function () {
      if (window.innerWidth >= 990) {
        const _this = this;
        timeoutHandle = setTimeout(function () {
          _this.setAttribute('open', '');
        }, 300);
      }
    });

    menu.addEventListener('mouseleave', function () {
      if (window.innerWidth >= 990) {
        clearTimeout(timeoutHandle);
        this.removeAttribute('open');
      }
    });
  });
});
/*
fetch('https://d4e036-0b.myshopify.com/api/2025-04/graphql', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': 'c2e8ec54f37aa76f18183a939f2dd418',
  },
  body: JSON.stringify({
    query: `query Products {
  products(first: 20, query: "metafields.ArtikelID.ArtikelID:\"1947\"") {
    edges {
      node {
        id
        title
        metafield(namespace: "ArtikelID", key: "ArtikelID") {
          value
        }
        updatedAt
        createdAt
      }
    }
  }
}`,
  }),
})
  .then((response) => response.json())
  .then((data) => {
    console.log(data);

    // Alle Metafields des Produkts auslesen
    /*const product = data.data.products.edges[0].node;
    const metafields = product.metafields.edges.map((metafield) => ({
      namespace: metafield.node.namespace,
      key: metafield.node.key,
      value: metafield.node.value,
    }));

    console.log('Alle Metafields:', metafields);
  })
  .catch((error) => console.error('Fehler:', error));*/

/* DAS GEHT 
fetch('https://d4e036-0b.myshopify.com/api/2025-04/graphql', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': 'c2e8ec54f37aa76f18183a939f2dd418',
  },
  body: JSON.stringify({
    query: `query tumbleDryProducts {
        collection(handle: "fruhstuck") {
          handle
          products(first: 1,
          filters: {
              variantMetafield:{
                namespace:"artikelid",
                key:"artikelid",
                value:"1947"
              }
            }) {
            edges {
              node {
                id
                title
                metafields(identifiers: [{ namespace: "Zutatenliste", key: "Zutatenliste" }]) {
            namespace
            key
            value
          }
              }
            }
          }
        }
      }`,
  }),
})
  .then((response) => response.json())
  .then((data) => {
    console.log('Produkte mit Material "cotton":', data);
  })
  .catch((error) => console.error('Fehler:', error));



fetch('https://d4e036-0b.myshopify.com/api/2025-04/graphql', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': 'c2e8ec54f37aa76f18183a939f2dd418',
  },
  body: JSON.stringify({
    query: `query Products {
  products(first: 1, query: "variants.sku:'11908'") {
    edges {
      node {
        id
        title
        variants(first: 1) {
          edges {
            node {
              sku
            }
          }
        }
      }
    }
  }
}`,
  }),
})
  .then((response) => response.json())
  .then((data) => {
    console.log('prod:', data);
  })
  .catch((error) => console.error('Fehler:', error));
*/
/* BY ID 


fetch('https://d4e036-0b.myshopify.com/api/2024-07/graphql', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': 'c2e8ec54f37aa76f18183a939f2dd418',
  },
  body: JSON.stringify({
    query: `query GetProductByID {
  product(id: "gid://shopify/Product/9877050294613") {
    id
    title
    variants(first: 5) {
      edges {
        node {
          id
          sku
          title
        }
      }
    }
  }
}
`,
  }),
})

*/

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    const addedNodesArray = Array.from(mutation.addedNodes); // addedNodes in ein Array umwandeln
    const listItemSlide = addedNodesArray.find(
      (node) => node.nodeType === 1 && node.classList.contains('list-item-slide')
    );

    if (listItemSlide) {
      initSplideSlider();
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.data-slide-in-box-item').length > 0) {
    const fadeItems = document.querySelectorAll('.data-slide-in-box');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!entry.target.classList.contains('isLoaded')) {
              entry.target.querySelectorAll('.data-slide-in-box-item').forEach((item) => {
                item.classList.add('isLoaded');
              });
            }
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -1px 0px' }
    );

    fadeItems.forEach((fadeItem) => {
      observer.observe(fadeItem);
    });
  }
  if (document.querySelectorAll('.data-fadein-box-item').length > 0) {
    const fadeItems = document.querySelectorAll('.data-fadein-box-item');
    let iterationSec = 500;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!entry.target.classList.contains('isLoaded')) {
              // Wenn das Element die Klasse "data-fadein-box-fast" hat, Zeit reduzieren
              entry.target.classList.add('isLoaded');
            }
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -1px 0px' }
    );

    fadeItems.forEach((fadeItem) => {
      observer.observe(fadeItem);
    });
  }
  if (document.querySelectorAll('.product-ambient-video-wrap').length > 0) {
    const playButton = document.querySelector('.product-ambient-video-play');
    const videoWrap = document.querySelector('.product-ambient-video-wrap');
    const video = videoWrap.querySelector('video');

    playButton.addEventListener('click', () => {
      video.controls = true;
      video.play();
      videoWrap.classList.add('playing');
    });
  }
  if (document.querySelectorAll('.item-naehrwert-set').length > 0) {
    getSetItems();
  }
});

window.initSplideSlider = initSplideSlider;
